import { SelectItem } from 'primereact/selectitem';

export const EnumToOptions = (enums: Record<string, string>): SelectItem[] => {
  return Object.entries(enums)
    .map((entry) => ({
      label: entry[1],
      value: entry[0],
    }))
    .sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
};
